module.exports = __webpack_public_path__ + "static/media/serv_charpente.577d95a3.png";